"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dblogsRoutes = void 0;
const dblogsActions_openapi_1 = require("./dblogsActions.openapi");
exports.dblogsRoutes = [
    {
        name: 'dblogs.filters',
        path: ['/filters'],
        method: 'GET',
        plugins: {
            openapi: dblogsActions_openapi_1.dblogsOpenApiDocs['dblogs.filters']
        }
    },
    {
        name: 'dblogs.search',
        path: ['/search'],
        method: 'POST',
        plugins: {
            openapi: dblogsActions_openapi_1.dblogsOpenApiDocs['dblogs.search']
        }
    },
];
